
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[id]",
      function () {
        return require("private-next-pages/docs/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/[id]"])
      });
    }
  